import React from "react";
import { Component } from "react";
import { Route, Redirect } from "react-router-dom";
import authService from "./AuthorizeService";
import authApiService from '../../adapters/xhr/AuthApiService';

export default class AuthorizeRoute extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
      didGetAntiforgeryToken: false,
      authenticated: false
    };
  }

  async componentDidMount() {
    await authApiService.createAntiforgeryToken(async () => {
      const authenticated = await authService.isAuthenticated();
      this.setState({ didGetAntiforgeryToken: true, ready: true, authenticated });
    });
  }

  render() {
    const { ready, didGetAntiforgeryToken, authenticated } = this.state;
    var link = document.createElement("a");
    link.href = this.props.path;
    const returnUrl = `${link.protocol}//${link.host}${link.pathname}${link.search}${link.hash}`;
    const redirectUrl = `/login?returnUrl=${encodeURIComponent(returnUrl)}`;
    if (!ready || !didGetAntiforgeryToken) {
      return <div></div>;
    }

    if (!authenticated) {
      return <Redirect to={redirectUrl} />;
    } else {
      const { component: Component, layout: Layout, ...rest } = this.props;
      return (
        <Route
          {...rest}
          render={(props) => {
              if (Layout) {
                return (
                  <Layout>
                    <Component {...props} />
                  </Layout>
                );
              } else {
                return <Component {...props} />;
              }
          }}
        />
      );
    }
  }

}
